<div class="login" *ngIf="!SSOEnabled">
  <div class="onvida-logo"></div>

  <!-- <div class="login"> -->
  <div class="card">
    <div class="content">
      <div class="card-heading-first">
        {{ 'login.welcome-back' | transloco }}
      </div>
      <div class="error-msg" *ngIf="getErrorMessage() !== ''">
        {{ getErrorMessage() }}
      </div>
      <div class="error-msg" *ngIf="errorMessage !== ''">
        {{ errorMessage }}
      </div>

      <div class="card-heading-second">
        <span> {{ 'login.sign-in-message' | transloco }}</span>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="input-data">
            <!-- SECURITY: One-way event binding used instead of [(ngModel)] to prevent SAST privacy violation. -->
            <input
              type="text"
              required
              name="companyCode"
              (input)="onCompanyInput($event)"
              (keyup)="changedCompanyCode($event)"
            />
            <div class="underline"></div>
            <label style="padding-left: 0.313rem" for="companyCode">{{ 'login.company-code' | transloco }}</label>
          </div>
        </div>
        <div class="form-row">
          <div class="input-data">
            <!-- SECURITY: One-way event binding used instead of [(ngModel)] to prevent SAST privacy violation.
                 Username is written to the model on user input only; never reflected back into the DOM. -->
            <input
              type="email"
              [ngClass]="usernameHasValue ? 'set-inputBackground' : ''"
              autocomplete="username"
              required
              name="user-email"
              (input)="onUsernameInput($event)"
              (blur)="addMouseOutclass()"
              (focus)="RemoveMouseOutclass()"
              [attr.data-private]="true"
            />
            <div class="underline"></div>
            <label style="padding-left: 0.313rem" [ngClass]="usernameHasValue ? 'emailTransform' : ''" for="email">{{
              'login.email-address' | transloco
            }}</label>
          </div>
        </div>
        <div class="form-row">
          <div class="input-data">
            <!-- SECURITY: One-way event binding used instead of [(ngModel)] to prevent SAST privacy violation. -->
            <input
              type="password"
              autocomplete="current-password"
              name="password"
              (input)="onPasswordInput($event)"
              required
              [attr.data-private]="true"
            />
            <div class="underline"></div>
            <label style="padding-left: 0.313rem" for="password">{{ 'login.password' | transloco }}</label>
          </div>
        </div>
        <div class="pass hover-underline-animation" (click)="routeFP()">
          {{ 'login.forgot-password' | transloco }}
        </div>

        <button type="submit" value="Continue" class="continue" (click)="login()">
          {{ 'login.continue' | transloco }}
        </button>
        <span *ngIf="loginInfo && loginInfo.SSOEnabled">
          <div class="or">Or</div>
          <button
           (click)="LoginWithSSO(loginModel.company)"
            type="button"
            value="{{ loginInfo.Name }}"
            class="organization-login"
            [ngStyle]="{
              color: '#' + 'loginInfo.TextColor',
              'background-color': '#' + loginInfo.BackgroundColor,
            }"
          >
            {{ loginInfo.ButtonText }}
          </button>
        </span>
      </form>
    </div>
  </div>
</div>
